import {IServiceHub} from './interfaces/services'
import {XyGisLayerInfosService, WFSLayerInfosService, BgTransService, SourcesService, GisCrudService} from './services'

class ServiceHubClass implements IServiceHub {
  gisCrudService: GisCrudService
  XyGisLayerInfosService: XyGisLayerInfosService
  WFSLayerInfosService: WFSLayerInfosService
  BgTransService: BgTransService
  SourcesService: SourcesService
}
export const ServiceHub = new ServiceHubClass() as IServiceHub
